import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import ExperienceSmartLiving from "@/pages/ExperienceSmartLiving";
import Calculator from "@/pages/Calculator";
import Contact from "@/pages/Contact";
import AdminLeads from "@/pages/AdminLeads";
import About from "@/pages/About";
import Warranty from "@/pages/Warranty";

function AppShell({ children, hideFooter = false }) {
    return (
        <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">{children}</main>
            {!hideFooter && <Footer />}
            <Toaster position="top-right" richColors />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<AppShell><Home /></AppShell>} />
                <Route path="/experience-smart-living" element={<AppShell hideFooter><ExperienceSmartLiving /></AppShell>} />
                <Route path="/calculator" element={<AppShell><Calculator /></AppShell>} />
                <Route path="/contact" element={<AppShell><Contact /></AppShell>} />
                <Route path="/about" element={<AppShell><About /></AppShell>} />
                <Route path="/warranty" element={<AppShell><Warranty /></AppShell>} />
                <Route path="/admin/leads" element={<AppShell><AdminLeads /></AppShell>} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
